import gql from 'graphql-tag'
import { JOB_BASED_FRAGMENT, JOB_FRAGMENT } from '~/common/apollo/apollo.fragment'

export const CREATE_SAVE_MUTATION = gql`
	mutation CreateSavedFilterMutation(
		$name: String
		$alertEmail: String
		$frequency: String
		$enableAlert: Boolean
		$alertChannels: JSON
		$pauseAlert: Boolean
		$pauseAlertPeriod: String
		$pauseAlertUntil: ISO8601Date
		$filterCondition: JobFilter
		$specificScope: String
	) {
		createSavedFilter(
			name: $name
			alertEmail: $alertEmail
			frequency: $frequency
			enableAlert: $enableAlert
			alertChannels: $alertChannels
			pauseAlert: $pauseAlert
			pauseAlertPeriod: $pauseAlertPeriod
			pauseAlertUntil: $pauseAlertUntil
			filterCondition: $filterCondition
			specificScope: $specificScope
		) {
			alertChannels
			enableAlert
			externalId
			filterCondition {
				conditions
				externalId
				id
			}
			frequency
			id
			lastAlertedAt
			name
			pauseAlert
			pauseAlertPeriod
			pauseAlertUntil
			startPauseAlertDate
			specificScope
		}
	}
`
export const UPDATE_SAVE_MUTATION = gql`
	mutation UpdateSavedFilter(
		$name: String
		$alertEmail: String
		$frequency: String
		$enableAlert: Boolean
		$alertChannels: JSON
		$pauseAlert: Boolean
		$pauseAlertPeriod: String
		$pauseAlertUntil: ISO8601Date
		$filterCondition: JobFilter
		$id: String
		$specificScope: String
	) {
		updateSavedFilter(
			name: $name
			alertEmail: $alertEmail
			frequency: $frequency
			enableAlert: $enableAlert
			alertChannels: $alertChannels
			pauseAlert: $pauseAlert
			pauseAlertPeriod: $pauseAlertPeriod
			pauseAlertUntil: $pauseAlertUntil
			filterCondition: $filterCondition
			id: $id
			specificScope: $specificScope
		) {
			alertChannels
			enableAlert
			externalId
			filterCondition {
				conditions
				externalId
				id
			}
			frequency
			id
			lastAlertedAt
			name
			pauseAlert
			pauseAlertPeriod
			pauseAlertUntil
			startPauseAlertDate
			specificScope
		}
	}
`

export const DELETE_SAVE_MUTATION = gql`
	mutation DeleteSavedFilter($id: String) {
		destroySavedFilter(id: $id) {
			id
			success
		}
	}
`

export const SYNC_ANONYMOUS_WORKER_DATA = gql`
	mutation SyncAnonymousWorkerData(
		$savedFilters: [SavedFilterInput!]
		$favoriteJobsAttributes: [FavoriteOrUnfavoriteJobInput!]
		$workerViewedObjectsAttributes: [WorkerViewedObjectInput!]
	) {
		syncAnonymousWorkerData(
			savedFilters: $savedFilters
			favoriteJobsAttributes: $favoriteJobsAttributes
			workerViewedObjectsAttributes: $workerViewedObjectsAttributes
		) {
			success
		}
	}
`

export const GET_LIST_BOOK_MARK = gql`
	query getListFavoriteJobs($after: String, $before: String, $last: Int, $first: Int) {
		favoritedJobs(after: $after, before: $before, last: $last, first: $first) {
			nodes {
				...jobBasedFragment
			}
			pageInfo {
				endCursor
				hasNextPage
				hasPreviousPage
				pageSize
				startCursor
			}
			totalCount
		}
	}
	${JOB_BASED_FRAGMENT}
`

export const BOOKMARK_A_JOB_MUTATION = gql`
	mutation BookmarkAJob($jobId: String!, $action: BookmarkActionEnum!) {
		bookmarkAJob(jobId: $jobId, action: $action) {
			...jobFragment
		}
	}
	${JOB_FRAGMENT}
`
